import metaobjectConverter from "core/services/metaStoreService/metaobject-converter";
import streamDataLoader from "./stream-data-loader";
import {
    setStreamPreviewVisibleAction,
    setStreamGraphPreviewVisibleAction,
    closeAllSidebarsAction
} from "../../../../stores/redux/features/flowdesigner/flowdesigner.slice";

/**
 * Starts the stream preview for a given node model.
 * Handles both Foreseer CQ nodes (graph + table preview) and regular Stream nodes (table preview only).
 */
export const previewData = (dispatch: (action: any) => void, model: any): void => {
    const isForeseerCQ = model.metaObject.type === "CQ" && model.metaObject.uiconfig?.subType === "Foreseer";
    const isStream = model.metaObject.type === "STREAM";

    if (isForeseerCQ) {
        const streamShortName = metaobjectConverter.convertFullNameToShortName(model.metaObject.output);
        const cqFQN = model.metaObject.get ? model.metaObject.get("id") : model.metaObject.id;
        streamDataLoader.previewSourceName = metaobjectConverter.getName(cqFQN);
        streamDataLoader.setStreamName(streamShortName);
        streamDataLoader.start();
        dispatch(closeAllSidebarsAction());
        dispatch(setStreamGraphPreviewVisibleAction(true));
        dispatch(setStreamPreviewVisibleAction(true));
    } else if (isStream) {
        const streamFQN = model.metaObject.get ? model.metaObject.get("id") : model.metaObject.id;
        const streamShortName = metaobjectConverter.convertFullNameToShortName(streamFQN);
        streamDataLoader.previewSourceName = metaobjectConverter.getName(streamFQN);
        streamDataLoader.setStreamName(streamShortName);
        streamDataLoader.start();
        dispatch(closeAllSidebarsAction());
        dispatch(setStreamGraphPreviewVisibleAction(false));
        dispatch(setStreamPreviewVisibleAction(true));
    }
};
